document.addEventListener('DOMContentLoaded', () => {
  const homeSlide = document.getElementById('homeSlide');
  if (!homeSlide) return;

  const slideCount = homeSlide.querySelectorAll('.splide__slide').length;
  if (slideCount === 0) return;

  let splide = null;

  const options = {
    type: 'loop',
    perPage: 3,
    autoplay: true,
    interval: 3500,
    speed: 500,
    easing: 'cubic-bezier(0,1,.75,1.1)',
    gap: '24px',
    focus: 'center',
    pagination: false,
    breakpoints: {
      840: {
        perPage: 2,
        focus: 0,
      },
      640: {
        perPage: 1,
        arrows: false,
        pagination: true,
      },
    },
  };

  function shouldStatic() {
    const width = window.innerWidth;

    if (width >= 841) {
      return slideCount <= 3;
    }

    if (width >= 641) {
      return slideCount <= 2;
    }

    return slideCount <= 1;
  }

  function setupHomeSlide() {
    if (shouldStatic()) {
      homeSlide.classList.add('is-static');
      homeSlide.classList.remove('is-slider');

      if (splide) {
        splide.destroy();
        splide = null;
      }
    } else {
      homeSlide.classList.add('is-slider');
      homeSlide.classList.remove('is-static');

      if (!splide) {
        splide = new Splide(homeSlide, options);
        splide.mount();
      }
    }
  }

  setupHomeSlide();

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      setupHomeSlide();
    }, 200);
  });
});
